import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJobChooseCandidate = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "job-choose-candidate" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.011,23.25l.1-1.122a3,3,0,0,0-2.337-3.2l-3.651-.811V12.375a2.029,2.029,0,0,0-1.949-1.86,1.846,1.846,0,0,0-1.8,1.86v9.2L11.9,20.472a1.533,1.533,0,0,0-2.146,2.145l.475.633"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 14.875,
			cy: 3.375,
			r: 2.625
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.625,9a4.25,4.25,0,0,0-7.5,0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 4.375,
			cy: 12.375,
			r: 2.625
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.125,18a4.25,4.25,0,0,0-7.5,0"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.625,
			y1: 4.5,
			x2: 8.125,
			y2: 4.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.625,
			y1: 1.5,
			x2: 8.125,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 20.125,
			y1: 4.5,
			x2: 21.625,
			y2: 4.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 20.125,
			y1: 1.5,
			x2: 21.625,
			y2: .75
		})
	]
});
export default SvgJobChooseCandidate;
